module.exports = "<div class=\"input-group input-group-sm\" style=\"margin-bottom: 10px\" *ngFor=\"let opcion of opciones\">\n    <span class=\"input-group-btn\">\n        <button class=\"btn {{style}}\" type=\"button\" (click)=\"setValue(opcion)\" [ngClass]=\"{'active': value === opcion}\">\n            <i class=\"fa\" [ngClass]=\"{'fa-circle-o': value !== opcion, 'fa-dot-circle-o':  value === opcion}\"></i>\n        </button>\n    </span>\n    <input type=\"text\" class=\"form-control\" placeholder=\"\" value=\"{{opcion}}\" readonly>\n</div><!-- /input-group -->"


//////////////////
// WEBPACK FOOTER
// ./app/_extra/ui/radio.component.html
// module id = 481
// module chunks = 0